import {label} from "@/class/label";
import {Media} from "@/class/data-type";

export class xrayspot extends label{
    
    objectType = "xrayspot";
    parentObjectType = "interactive_image";
    
    data = [
        ...this._default.coords,
        ...this._default.pointer,
        {name: "image", type: Media, default: new Media({type:"picture"})},
        {name: "diameter", type:Number, default: 0.0}
    ]
    
    constructor() {
        super();
        this.init();
    }
}